
import { useState, useRef } from "react";

import "./styles.scss";

import api from "@helpers/api";

import CustomModal from "@components/CustomModal";
import ImageImportTool from "@components/ImageImportTool";

import {Input} from "@fragments";


export default function ConfigPlaylistModal({ modalRef }) {
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    const REF_config = useRef({});
    const REF_callback = useRef();

    modalRef.current = {
        open(preFill, callback) {
            REF_config.current = { ...preFill };
            REF_callback.current = callback;
            setOpen(true);
        },
    };

    async function handleSubmit() {
        try {
            setLoading(true);
            const payload = getPayload();

            const { data } = await api.post("section/playlist", payload);

            if (data.id) {
                await REF_callback.current(data);
                setOpen(false);
            }
        } catch (e) {
            console.log(e);
        }

        setLoading(false);

        function getPayload() {
            const { id, name, description, banner_base64, section } =
                REF_config.current;

            const data = {
                section: parseInt(section),
                name: name.trim(),
                description: description?.trim(),
            };

            if (!!id) {
                data.id = id;
            }
            if (!!banner_base64 && !banner_base64?.startsWith("http")) {
                data.banner_base64 = banner_base64;
            }

            return data;
        }
    }

    async function handleDelete() {
        try {
            const { data } = await api.delete("section/playlist", {
                id: REF_config.current.id,
            });
            REF_callback.current();
        } catch (e) {
            console.log(e);
        }

        setOpen(false);
    }

    return (
        <CustomModal
            maxWidth={450}
            bottomButtonSumbitText="Salvar sessão"
            bottomButtonCancelText="Cancelar"
            loading={loading}
            handleDelete={REF_config.current?.id && handleDelete}
            deletionTitle="Você realmente deseja apagar esta playlist permanentemente?"
            title="Editar playlist"
            handleSubmit={handleSubmit}
            open={open}
            handleClose={() => setOpen(false)}
            bodyComponent={
                open ? (
                    <div className="px-4 pb-1 py-3">
                        <ImageImportTool
                            aspectRatio={4 / 3}
                            size={120}
                            imageMaxWidth={1600}
                            src={
                                REF_config.current.banner_base64 || REF_config.current.banner
                            }
                            onLoaded={(imageBase64) => {
                                REF_config.current.banner_base64 = imageBase64;
                            }}
                            title="Redimensionar banner da playlist"
                            className="playlist-banner-input"
                        />
                        <Input.Text
                            className="mt-4"
                            autoFocus={true}
                            placeholder="Nome da playlist"
                            value={REF_config.current.name}
                            onInput={(v) => {
                                REF_config.current.name = v;
                            }}
                            label="Insira o nome da playlist"
                            size={50}
                        />
                        <Input.Text
                            className="mt-2"
                            multiline
                            placeholder="Descrição da playlist"
                            value={REF_config.current.description}
                            onInput={(v) => {
                                REF_config.current.description = v;
                            }}
                            label="Adicione uma descrição resumida para a playlist"
                            size={250}
                        />
                    </div>
                ) : null
            }
        />
    );
}